import { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

const DeleteConfirmationDialog = ({ data, sdk }: { data: any, sdk: any }) => {
    const [confirmationText, setConfirmationText] = useState('');
    const searchWord: string = data?.searchWord || 'löschen';

    const handleConfirm = () => {
        if (confirmationText.toLowerCase() === searchWord) {
            setConfirmationText('');
            if (data?.callback) {
                data.callback(true);
                sdk.closeDeleteConfirmationDialog();
            }
        }
    };

    const handleCancel = () => {
        setConfirmationText('');
        if (data?.callback) {
            data.callback(false);
            sdk.closeDeleteConfirmationDialog();
        }
    }


    return (
        <Dialog
            visible={true}
            modal
            header={data?.title || 'Bestätigung'}
            footer={() => (
                <div>
                    <Button
                        label="Abbrechen"
                        icon="pi pi-times"
                        className="p-button-secondary"
                        onClick={handleCancel}
                    />
                    <Button
                        label={'Löschen'}
                        icon="pi pi-check"
                        className="p-button-danger"
                        onClick={handleConfirm}
                        disabled={confirmationText.toLowerCase() !== searchWord}
                    />
                </div>
            )}
            style={{ maxWidth: '500px', width: '90%' }}
            onHide={handleCancel}
        >
            <div style={{ marginBottom: '1rem' }}>
                {data?.text || ''}
            </div>
            <InputText
                value={confirmationText}
                onChange={(e) => setConfirmationText(e.target.value)}
                placeholder={searchWord}
                style={{ width: '100%' }}
            />
        </Dialog>
    );
};

export default DeleteConfirmationDialog;